import React from "react";
import ContainerBox from "../../../common/components/container-box";
import Progress from "../../../common/components/progress";
import Error, { mapApplicationErrorInfoToErrorComponentProps } from "../../../common/components/error-new";
import useMyTasksController, { IMyTasksController } from "./controller";
import "./index.scss";
import RequestsTable from "../requests-table";
import { createFunctionalComponentFromView } from "../../../utils/view-controller";
import NoTasksAvailable from "../asserts/image/NoTasksAvailable.png";

const MyTasks = createFunctionalComponentFromView<IMyTasksController>(
  useMyTasksController,
  (controller) => {
    const renderContent = () => {
      if (controller.shouldRenderProgressMessage()) {
        return <Progress text={controller.fetchAssignedRequestsProgress} />;
      }
      if (controller.shouldRenderError()) {
        return (
          <Error

            {...mapApplicationErrorInfoToErrorComponentProps(controller.fetchAssignedRequestsError!)}
            onClick={controller.onClickRetryButton}
          />
        );
      }
      if (controller.shouldRenderNoRequestsMessage()) {
        return renderNoTasksMessage();
      }
      return renderRequests();
    };

    const renderRequests = () => (
      <RequestsTable
        requests={controller.assignedRequests}
        onRowClickedHandler={controller.onTableRowClickedHandler}
      />
    );

    const renderNoTasksMessage = () => (
      <div className="no-tasks-available">
        <img
          alt="no-tasks-available"
          src={NoTasksAvailable}
        />
        <div>It appears there are no tasks for your team(s).</div>
      </div>
    );

    return (
      <div className="MyTasks">
        <ContainerBox>
          <div className="requests-container">
            {renderContent()}
          </div>
        </ContainerBox>
      </div>
    );
  },
);

export default MyTasks;
